export const COLORS = {
  sky: '#5BAFD6',
  skyDark: '#2C7FAD',
  skyLight: '#E8F5FB',
  sun: '#F5A623',
  sunLight: '#FEF3DC',
  leaf: '#5BAD72',
  leafLight: '#E8F7ED',
  coral: '#E07B5B',
  coralLight: '#FDEEE9',
  cream: '#FDFAF5',
  dark: '#2C3A47',
  mid: '#5A6A77',
  border: 'rgba(44,58,71,0.12)',
};

export const PHONES = [
  { label: '', number: '2069728281', display: '(206) 972-8281' },
  { label: '', number: '2063764472', display: '(206) 376-4472' },
];
